<template>
  <div class="reservation-map">
    <div ref="map" :style="{ height: height + 'px' }"></div>
  </div>
</template>

<script>
export default {
  name: 'ReservationMap',
  props: {
    height: {
      type: Number
    },
    cars: {
      type: Array
    },
    start: {
      type: String
    },
    end: {
      type: String
    }
  },
  computed: {
    loadedCars () {
      return this.updatedCars || this.cars
    }
  },
  data () {
    return {
      map: false,
      oms: false,
      markers: [],
      updatedCars: false,
      infowindow: false,
      lat: -37.7530522,
      lng: 144.9666907
    }
  },
  methods: {
    async init (cars) {
      for (let marker of this.markers) {
        marker.setMap(null)
        this.oms.removeMarker(marker)
      }
      this.markers = []
      if (cars.length) this.updatedCars = cars
      this.getLocation()
      if (!this.map) {
        let centre = {
          lat: this.lat,
          lng: this.lng
        }
        this.map = new google.maps.Map(this.$refs.map, {
          center: centre,
          zoom: 15
        })
        let image = '/images/you-are-here-marker.png'
        let latlng = new google.maps.LatLng(this.lat, this.lng)
        this.markers.push(new google.maps.Marker({
          map: this.map,
          position: latlng,
          icon: image,
          optimized: false,
          zIndex: 0
        }))
        google.maps.event.addListenerOnce(this.map, 'idle', () => {
          google.maps.event.trigger(this.map, 'resize')
          this.map.panTo(centre)
        })
        this.oms = new OverlappingMarkerSpiderfier(this.map, {
          keepSpiderfied: true
        })
        for (let i in this.loadedCars) {
          let car = this.loadedCars[i]
          this.addCar(car, i)
        }
        this.oms.addListener('click', (m, event) => {
          if (this.infowindow) this.infowindow.close()
          this.infowindow = new google.maps.InfoWindow({
            content: m.desc
          })
          this.infowindow.open(this.map, m)
          this.map.panTo(m.position)
          if (this.map.getZoom() < 11) {
            this.map.setZoom(11)
          }
          if (m.button) {
            m.button.removeEventListener('click', this.handleClick)
            m.button.addEventListener('click', this.handleClick)
          }
        })
      } else {
        for (let i in this.loadedCars) {
          let car = this.loadedCars[i]
          this.addCar(car, i)
        }
        let image = '/images/you-are-here-marker.png'
        let latlng = new google.maps.LatLng(this.lat, this.lng)
        this.markers.push(
          new google.maps.Marker({
            map: this.map,
            position: latlng,
            icon: image,
            optimized: false,
            zIndex: 0
          })
        )
      }
    },
    getLocation () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          this.lat = position.coords.latitude
          this.lng = position.coords.longitude
          this.$emit('location', { lat: this.lat, lng: this.lng })
        })
      }
    },
    addCar (car, key) {
      let lot = car.Lot
      let relocationEndTime = false
      // loop through pending relocations
      for (let relocation in car.LotRelocations) {
        // if the relocation is permanent
        if (relocation.permanent) {
          // if the booking is after the relocation
          if (moment(relocation.endDate).isBefore(this.start)) {
            // if there is a previously found relocation and its before the
            // found relocation OR if there is no previously found relocation
            if ((relocationEndTime && moment(relocationEndTime).isBefore(relocation.endDate)) || !relocationEndTime) {
              lot = relocation.Lot
              relocationEndTime = relocation.endDate
            }
          }
        } else {
          // temporary relocations
          // if the booking times are between the relocation
          if (moment(this.start).isBetween(relocation.startDate, relocation.endDate) &&
            moment(this.end).isBetween(relocation.startDate, relocation.endDate)) {
            lot = relocation.Lot
          }
        }
      }
      if (lot) {
        let latlng = new google.maps.LatLng(lot.latitude, lot.longitude)
        let image = '/images/marker-unavailable.png'
        let infoElement = document.createElement('div')
        let info =
        `<img class="pull-left" style="width: 100px;"
          src="https://techcar-dev.s3.amazonaws.com/${car.CarType.AmazonImage.objectKey}"/>
          <label class="col-form-label">${car.CarType.name}</label>
          <p>(#${car.convadisId} - ${car.name})</p>
          <p>${lot.address}</p>`
        let zIndex = 0
        if (car.Reservations.length < 1) {
          image = '/images/marker-available.png'
          info += `
            <p><button class="btn btn-sm btn-default marker-reserve"
            id="marker_reserve_${key}">Reserve</button>
            <a href="/reserve/car/${car.uuid}?s=" class="btn btn-primary btn-sm">
            View Availability</a></p>`
          zIndex = 2
        } else {
          info += `
            <p class="text-muted">Unavailable<br/>
            <a href="/reserve/car/${car.uuid}?s=" class="btn btn-default btn-sm">
            View Availability</a></p>`
          zIndex = 1
        }
        let marker = new google.maps.Marker({
          map: this.map,
          position: latlng,
          icon: image,
          optimized: false,
          zIndex
        })
        infoElement.innerHTML = info
        let button = infoElement.getElementsByTagName('button')[0]
        marker.desc = infoElement
        marker.button = button
        this.oms.addMarker(marker)
        this.markers.push(marker)
      }
    },
    handleClick (e) {
      let id = e.target.id.replace('marker_reserve_', '')
      this.$emit('reserve', this.loadedCars[id])
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ReservationMap.vue